"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setNovelToken = exports.getAccountInfoSuccess = void 0;
const tslib_1 = require("tslib");
const novel_open_fetch_1 = tslib_1.__importDefault(require("@tencent/novel-open-fetch"));
const qb = tslib_1.__importStar(require("./qb"));
const cookie = tslib_1.__importStar(require("./cookie"));
const TOKEN_URL = 'https://bookshelf.html5.qq.com/qbread/api/passport/token';
let defer;
function requestNovelToken(token) {
    if (defer)
        return defer;
    defer = new Promise((resolve, reject) => {
        let tokenUrl = TOKEN_URL;
        if (token)
            tokenUrl = `${TOKEN_URL}?token=${token}`;
        novel_open_fetch_1.default.get(tokenUrl).then((res) => {
            if (res.code === 0) {
                resolve({
                    code: res.code,
                    msg: res.msg,
                });
            }
            else {
                reject({
                    code: res.code,
                    msg: res.msg,
                });
            }
        });
    });
    return defer;
}
/**
 * 将用户的登录票据按照小说的规则设置到Cookie中
 */
function getAccountInfoSuccess(params) {
    if (params) {
        const { qbid, appid, skey, type, token, uin } = params;
        cookie.setCookie('Q-H5-ACCOUNT', uin);
        cookie.setCookie('Q-H5-USERTYPE', type);
        cookie.setCookie('Q-H5-QBID', qbid);
        cookie.setCookie('uin', uin);
        const accountType = parseInt(type, 10);
        if (accountType === 2) {
            cookie.setCookie('Q-H5-TOKEN', token);
            cookie.delCookie('Q-H5-ID');
            cookie.setCookie('Q-H5-ID', appid);
        }
        else if (accountType === 1) {
            cookie.setCookie('Q-H5-SKEY', skey);
        }
        else if (accountType === 4) {
            if (qb.getIsQB()) {
                cookie.delCookie('Q-H5-ID');
                cookie.setCookie('Q-H5-ID', appid);
            }
        }
    }
    else {
        cookie.delLoginCookie();
    }
}
exports.getAccountInfoSuccess = getAccountInfoSuccess;
;
/**
 * 请求并设置小说票据
 */
function setNovelToken(params) {
    // 设置固定的cookie
    getAccountInfoSuccess(params);
    // 根据用户的usetype 选择更新token
    const { type, token } = params;
    const accountType = parseInt(type, 10);
    return requestNovelToken(accountType === 4 ? token : 0);
}
exports.setNovelToken = setNovelToken;
;
